import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { ParametrosKit } from "src/app/models/parametros-kit";
import { Produto } from "src/app/models/produto";
import { CarregandoService } from "src/app/services/carregando.service";
import { NotificacaoService } from "src/app/services/notificacao.service";
import { ParametrosKitService } from "src/app/services/parametros-kit.service";
import { ProdutoService } from "src/app/services/produto.service";
import { SelecionaProdutoV2ModalComponent } from "../seleciona-produto-v2-modal/seleciona-produto-v2-modal.component";
import { PremissasService } from "../../services/premissas.service";
import { PremissasSistema } from "../../models/premissas-sistema";
import { TipoFiltroProduto } from "../../models/enum";
import { SelecionaProdutoModalComponent } from "../seleciona-produto-modal/seleciona-produto-modal.component";

// jquery
declare const $: any;

@Component({
  selector: 'app-cadastra-combinacao-modal',
  templateUrl: './cadastra-combinacao-modal.component.html',
  styleUrls: ['./cadastra-combinacao-modal.component.scss']
})
export class CadastraCombinacaoModalComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};
  tipo: number;
  parametroKit: ParametrosKit;
  paineis: Produto[];
  stringboxes: Produto[];
  conectores: Produto[];
  cabos: Produto[];
  produtoPrincipal: number;
  editando: boolean;
  fases = [
    { id: 0, nome: 'Monofásico' },
    // { id: 1, nome: 'Bifásica' },
    { id: 2, nome: 'Trifásico' }
  ];
  tiposInv = [
    { id: 0, nome: 'String' },
    { id: 1, nome: 'Micro' },
    { id: 2, nome: 'Híbrido' },
  ];

  premissasSistema: PremissasSistema = new PremissasSistema();

  constructor(
    public dialogRef: MatDialogRef<CadastraCombinacaoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private produtoService: ProdutoService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private parametrosKitService: ParametrosKitService,
    public dialog: MatDialog,
    private premissasService: PremissasService
    ) {
    this.tipo = data.tipo;
    this.parametroKit = data.parametroKit;
    this.produtoPrincipal = data.produtoPrincipal;
    this.editando = data.editando;
  }

  ngOnInit() {
    this.buscarPremissasSistema().then();

    switch (this.tipo) {
      case 1:
        this.buscarPaineis();
        break;
      case 2:
        this.buscarConectores();
        break;
      case 3:
        this.buscarStringbox();
        break;
      case 4:
        this.buscarCabos();
        break;
    }
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  voltar() {
    this.dialogRef.close();
  }

  ok(layoutForm) {
    if (layoutForm.valid) {
      // let retorno = {
      //   tensaoSelecionada: this.tensaoSelecionada,
      //   faseSelecionada: this.faseSelecionada,
      //   painelSelecionado: this.paineis.find(p => p.idProduto === this.painelSelecionado)
      // }
      this.dialogRef.close();
      // this.contaEnergia.outrasCobrancas = Number(this.contaEnergia.outrasCobrancas.toString().replace(',','.'));
      // this.contaEnergia.idCupom = this.idCupom;
      // this.dialogRef.close(this.contaEnergia);
    }
  }

  salvar() {
    this.carregandoService.mostra('salvaParametro');

    if (this.parametroKit.potPainel !== undefined && this.parametroKit.potPainel !== null) {
      this.parametroKit.potPainel = Number(this.parametroKit.potPainel);
    }
    if (this.parametroKit.qtMin !== undefined && this.parametroKit.qtMin !== null) {
      this.parametroKit.qtMin = Number(this.parametroKit.qtMin);
    }
    if (this.parametroKit.qtMax !== undefined && this.parametroKit.qtMax !== null) {
      this.parametroKit.qtMax = Number(this.parametroKit.qtMax);
    }
    if (this.parametroKit.qtd !== undefined && this.parametroKit.qtd !== null) {
      this.parametroKit.qtd = Number(this.parametroKit.qtd);
    }
    if (this.parametroKit.total !== undefined && this.parametroKit.total !== null) {
      this.parametroKit.total = Number(this.parametroKit.total);
    }
    if (this.parametroKit.multiplo !== undefined && this.parametroKit.multiplo !== null) {
      this.parametroKit.multiplo = Number(this.parametroKit.multiplo);
    }
    if (this.tipo < 4) {
      this.parametroKit.produtoInversor = this.produtoPrincipal;
    }

    this.parametroKit.tipoParametro = this.tipo;
    this.parametrosKitService.salvar(this.parametroKit).subscribe(
      (retorno) => {

        this.notificacaoService.sucesso('Combinação salva com sucesso!!!');
        this.dialogRef.close(this.parametroKit);
        this.carregandoService.esconde('salvaParametro');
      },
      (erro) => {
        this.carregandoService.esconde('salvaParametro');
        this.notificacaoService.erro(erro);
      }
    );
  }


  validar() {
    return true;
    //return this.tensao !== undefined && this.tensao !== null && this.fase !== undefined && this.fase !== null;
  }

  buscarPaineis() {
    this.carregandoService.mostra('buscarPaineis');

    this.produtoService.listarPorFamilia(2).subscribe(dados => {
      this.paineis = dados;
      this.carregandoService.esconde('buscarPaineis');
    }, (erro) => {
      this.carregandoService.esconde('buscarPaineis');
      this.notificacaoService.erro(erro);
    });
  }

  buscarConectores() {
    this.carregandoService.mostra('buscarConectores');

    this.produtoService.listarPorFamilia(1).subscribe(dados => {
      this.conectores = dados;
      this.carregandoService.esconde('buscarConectores');
    }, (erro) => {
      this.carregandoService.esconde('buscarConectores');
      this.notificacaoService.erro(erro);
    });
  }

  buscarStringbox() {
    this.carregandoService.mostra('buscarStringbox');
    this.produtoService.listarPorFamilia(4).subscribe(dados => {
      this.stringboxes = dados;
      this.carregandoService.esconde('buscarStringbox');
    }, (erro) => {
      this.carregandoService.esconde('buscarStringbox');
      this.notificacaoService.erro(erro);
    });
  }

  buscarCabos() {
    this.carregandoService.mostra('buscarCabos');
    this.produtoService.listarPorFamilia(5).subscribe(dados => {
      this.cabos = dados;
      this.carregandoService.esconde('buscarCabos');
    }, (erro) => {
      this.carregandoService.esconde('buscarCabos');
      this.notificacaoService.erro(erro);
    });
  }

  selecionarProduto(tipoProduto: number) {
    const largura = Number(($('body').width()));
    let dialogRef;
    const config = {
      width: largura > 930 ? '900px' : $('body').width().toString() + 'px',
      data: {
        editando: false,
        semKit: true
      },
      panelClass: 'modal-card',
      maxHeight: '98vh'
    };

    if (this.premissasSistema.filtroProduto === TipoFiltroProduto.Agrupamento) {
      dialogRef = this.dialog.open(SelecionaProdutoModalComponent, config);
    } else {
      dialogRef = this.dialog.open(SelecionaProdutoV2ModalComponent, config);
    }

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (tipoProduto === 0) {
          this.parametroKit.produtoParametro = result.produto;
          this.parametroKit.produtoParametroDescricao = result.produtoTela.descricao;
        }
        else {
          this.parametroKit.produtoInversor = result.produto;
          this.parametroKit.produtoInversorDescricao = result.produtoTela.descricao;
        }
      }
    });

  }
}
